import React from "react";
import { Box } from "@mui/material";
import { loanManagementUrl } from "../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
const base_url = loanManagementUrl.uri;

const LoanSettings = () => {
  const actions = {
      // entity: localStorage.getItem("SelectedTabLabel"),
      entity:"LoanSettings",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate"],
      objectName: "loanSettings",
      parameters: "",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="LoanSettings Management"
        subtitle="Manage Loan Settings"
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default LoanSettings;
